import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';

export const CONTEXT_SELECTOR_TOKEN = new InjectionToken<ContextSelector>(
  'CONTEXT_SELECTOR_TOKEN',
  {
    providedIn: 'root',
    factory: () => null,
  },
);

export type OrgGroup = 'active' | 'favorites' | 'others';

export interface ContextItem {
  name: string;
  id: string;
  path: string | string[];
  isActive?: boolean;
  group?: OrgGroup;
}

export interface ContextSelector {
  /**
   * Number of items from which the search box is shown, inclusive. Below it the
   * dropdown renders the bare list — a search box over a handful of items is
   * noise that only hurts scanability.
   */
  readonly showSearchFromCount: number;
  readonly currentName: Signal<string | null>;
  readonly currentId: Signal<string | null>;
  readonly total: Signal<number>;
  readonly favorites: Signal<Set<string>>;

  getList(search: string): Observable<ContextItem[]>;
}
